module.exports = __webpack_public_path__ + "img/矩形 86@1x.06138055.png";